module.exports = __webpack_public_path__ + "static/img/juzhuzhengming.62504586.png";